<p-toast [style]="{ marginTop: '80px' }"></p-toast>
@if (formLoading) {
  <div class="progress-spinner">
    <app-spinner [formLoading]="formLoading"></app-spinner>
  </div>
}
@if (msgTopic) {
  <h2> Messages</h2>
}
<p-confirmDialog header="Confirmation" icon="pi pi-exclamation-triangle"></p-confirmDialog>

<div class="inbox-list-vertical-container">

  <!-- ─── Top Toolbar ─────────────────────────────────────────────────────── -->
  <div class="inbox-top-toolbar">

    <!-- Left: Unread toggle + filter dropdowns in one horizontal row -->
    <div class="toolbar-left-section">

      <!-- Unread only -->
      <div class="unread-toggle-wrap">
        <p-checkbox [(ngModel)]="showUnread" [binary]="true" inputId="showUnread"
        (onChange)="onShowUnreadChange()"></p-checkbox>
        <label for="showUnread" class="mb-0 unread-label">Conversation View</label>
      </div>

      <!-- Vertical separator -->
      @if (null == msgTopic) {
        <div class="toolbar-sep"></div>
      }

      <!-- Filter dropdowns (compact, horizontal) -->
      @if (null == msgTopic) {
        <div class="toolbar-filters-row">
          <div class="toolbar-filter-chip">
            <p-multiSelect
              dropdownIcon="fa fa-caret-down"
              appendTo="body"
              [options]="msgOriginFiltered"
              [displaySelectedLabel]="true"
              display="chip"
              [(ngModel)]="msgOriginIds"
              optionLabel="name"
              optionValue="value"
              placeholder="Msg Origin"
              (onChange)="pt.filter($event.value, 'msgOrigin', 'in')"
              styleClass="compact-filter-select">
            </p-multiSelect>
          </div>
          <div class="toolbar-filter-chip">
            <p-multiSelect
              dropdownIcon="fa fa-caret-down"
              appendTo="body"
              [options]="msgContexts"
              [displaySelectedLabel]="true"
              display="chip"
              [(ngModel)]="msgContextIds"
              optionLabel="name"
              optionValue="value"
              placeholder="Msg Context"
              (onChange)="onContextChange($event.value)"
              styleClass="compact-filter-select">
            </p-multiSelect>
          </div>
          <div class="toolbar-filter-chip">
            <p-multiSelect
              dropdownIcon="fa fa-caret-down"
              appendTo="body"
              [options]="msgSubContextsFiltered"
              [displaySelectedLabel]="true"
              display="chip"
              [(ngModel)]="msgSubContextIds"
              optionLabel="name"
              optionValue="value"
              placeholder="Sub Context"
              (onChange)="pt.filter($event.value, 'msgSubContext', 'in')"
              styleClass="compact-filter-select">
            </p-multiSelect>
          </div>
          <div class="toolbar-filter-chip">
            <p-multiSelect
              dropdownIcon="fa fa-caret-down"
              appendTo="body"
              [options]="msgRoles"
              [displaySelectedLabel]="true"
              display="chip"
              [(ngModel)]="msgRoleIds"
              optionLabel="name"
              optionValue="value"
              placeholder="Msg Role"
              (onChange)="pt.filter($event.value, 'msgRole', 'in')"
              styleClass="compact-filter-select">
            </p-multiSelect>
          </div>

          <app-email-directory [msgContextIds]="msgContextIds"></app-email-directory>

        </div>
      }
    </div>

    <!-- Right: Notification + Compose + Refresh -->
    <div class="toolbar-right">

      <!-- Notification Bell -->
      <div class="notification-wrapper">
        <button class="icon-btn-circle notification-bell-btn" (click)="notifPanel.toggle($event)" title="New Messages">
          <i class="pi pi-bell" [class.notif-bell-active]="notificationCount > 0"></i>
          @if (notificationCount > 0) {
            <span class="notification-badge">
              {{ notificationCount > 99 ? '99+' : notificationCount }}
            </span>
          }
        </button>
        <p-overlayPanel #notifPanel [showCloseIcon]="false" [dismissable]="true"
          [style]="{width: '360px', padding: '0'}">
          <div class="notification-panel-header">
            <span class="notification-panel-title">New Messages ({{ notificationCount }})</span>
            @if (notifications.length > 0) {
              <button class="notif-clear-btn" (click)="clearNotifications()"
              >Clear all</button>
            }
          </div>
          <div class="notification-list">
            @for (n of notifications; track n) {
              <div class="notification-item"
                (click)="onNotificationClick(n); notifPanel.hide()">
                <div class="notif-icon-wrap"><i class="pi pi-envelope notif-icon"></i></div>
                <div class="notif-content">
                  <div class="notif-subject">{{ n.subject || 'No Subject' }}</div>
                  <div class="notif-sender">{{ n.senderName || n.senderEmail }}</div>
                  <div class="notif-time">{{ n.createDate | date: 'MMM dd, h:mm a' }}</div>
                </div>
              </div>
            }
          </div>
        </p-overlayPanel>
      </div>

      <button pButton pRipple class="compose-btn" (click)="onOpenFormAddMailAndSMS()">
        <i class="pi pi-plus"></i> Compose
      </button>


      <button class="icon-btn-circle" (click)="refreshMails()" title="Refresh">
        <i class="pi pi-refresh"></i>
      </button>


      @if (isDialog) {
        <button class="icon-btn-circle" [mat-dialog-close]="true" title="Close">
          <i class="pi pi-times"></i>
        </button>
      }
    </div>
  </div>

  <div #mainContainer class="inbox-main-container" [class.detail-active]="selectedRow || mailPaneLoading">

    <div class="gmail-list-view"
      [class.list-panel]="selectedRow || mailPaneLoading"
      [style.flex]="(selectedRow || mailPaneLoading) ? leftSidebarFlex : null">

      <div class="gmail-nav-sidebar">

        <div class="gmail-nav-items">
          @for (item of mailBoxes; track item) {
            <button
              (click)="selectedmailbox = item.value; loadMailBox(item.value)"
              [pTooltip]="item.label" tooltipPosition="right"
              class="gmail-nav-item" [class.gmail-nav-active]="selectedmailbox === item.value">
              <i [class]="item.icon"></i>
              <span class="gmail-nav-label">{{ item.label }}</span>
            </button>
          }
        </div>

        <div class="gmail-nav-divider"></div>

        <div class="gmail-tags-section">

          <div class="gmail-tags-desktop">
            <div class="gmail-tags-heading">
              <span>Folders</span>
              <button class="gmail-tag-add-btn" (click)="openAddTagDialog()"
                pTooltip="New tag" tooltipPosition="right">
                <i class="pi pi-plus"></i>
              </button>
            </div>

            @if (allTags.length === 0) {
              <div class="gmail-tags-empty">No tags yet</div>
            }

            @for (tag of allTags; track tag) {
              <button
                class="gmail-nav-item gmail-tag-item"
                [class.gmail-nav-active]="selectedmailbox === 'tag' && selectedTagIds.includes(tag.tagId)"
                (click)="selectTag(tag)"
                [pTooltip]="tag.name" tooltipPosition="right">
                <i class="pi pi-tag"></i>
                <span class="gmail-nav-label">{{ tag.name }}</span>
              </button>
            }
          </div>

          <div class="gmail-tags-mobile">
            <p-multiSelect
              [options]="allTags"
              [(ngModel)]="selectedTagIds"
              optionLabel="name"
              optionValue="tagId"
              placeholder="Tags"
              display="chip"
              appendTo="body"
              [showClear]="selectedTagIds.length > 0"
              (onChange)="onMobileTagsChange($event.value)"
              styleClass="mobile-tag-multiselect">
            </p-multiSelect>
          </div>

        </div>

      </div>

      <div #leftSidebar class="inbox-left-sidebar gmail-fullwidth-list">

        <div class="gmail-list-header-bar">

          <div class="list-hdr-left">
            <p-checkbox [(ngModel)]="selectAllCheckbox" [binary]="true"
            (onChange)="selectAllCheckboxChanged()"></p-checkbox>

            @if (selectedMails.length > 0) {
              <span class="selected-count ms-1">{{ selectedMails.length }} selected</span>
              <div class="bulk-action-bar">
                @if (selectedmailbox !== '0') {
                  <button
                    class="bulk-action-btn" (click)="archiveSelected()"
                    [disabled]="isBulkArchiving"
                    pTooltip="Archive selected" tooltipPosition="bottom">
                    @if (isBulkArchiving) {
                      <i class="pi pi-spin pi-spinner"></i>
                    }
                    @if (!isBulkArchiving) {
                      <i class="pi pi-inbox"></i>
                    }
                    <span>{{ isBulkArchiving ? 'Archiving…' : 'Archive' }}</span>
                  </button>
                }
                @if (selectedmailbox === '0') {
                  <button
                    class="bulk-action-btn" (click)="unarchiveSelected()"
                    [disabled]="isBulkUnarchiving"
                    pTooltip="Restore selected to Inbox / Sent" tooltipPosition="bottom">
                    @if (isBulkUnarchiving) {
                      <i class="pi pi-spin pi-spinner"></i>
                    }
                    @if (!isBulkUnarchiving) {
                      <i class="pi pi-reply"></i>
                    }
                    <span>{{ isBulkUnarchiving ? 'Restoring…' : 'Unarchive' }}</span>
                  </button>
                }
              </div>
            }
          </div>

          <div class="gmail-search-wrap">
            <div class="gmail-search-box" [class.gmail-search-focused]="searchFocused">
              <i class="pi pi-search gmail-srch-icon-left"></i>

              <p-autoComplete
                [suggestions]="searchSuggestions"
                (completeMethod)="onSearchComplete($event)"
                (onSelect)="onSearchSuggestionSelect($event)"
                (onClear)="clearSearch()"
                (onFocus)="onSearchFocus()"
                (onBlur)="onSearchBlur()"
                [field]="'fullLabel'"
                [forceSelection]="false"
                [dropdown]="false"
                [style]="{'width':'100%'}"
                [inputStyle]="{'autocomplete':'new-password'}"
                placeholder="Search emails…"
                class="gmail-srch-autocomplete"
                [showClear]="!!searchKeyWork"
                inputId="inbox-search-nac">
                <ng-template let-item pTemplate="item">{{ item.fullLabel }}</ng-template>
              </p-autoComplete>

              <button class="gmail-srch-filter-btn"
                (click)="filterPanel.show($event, null, { my: 'center top', at: 'center bottom' })"
                pTooltip="Date filter" tooltipPosition="bottom">
                <i class="pi pi-filter"></i>
              </button>
            </div>

            @if (searchFocused && !searchKeyWork && recentSearches.length > 0) {
              <div class="gmail-recent-dropdown"
                (mousedown)="$event.preventDefault()">
                <div class="recent-srch-header">Recent searches</div>
                @for (term of recentSearches; track term) {
                  <div class="recent-srch-item"
                    (click)="applyRecentSearch(term)">
                    <i class="pi pi-history recent-srch-icon"></i>
                    <span class="recent-srch-text">{{ term }}</span>
                    <button class="recent-srch-remove"
                      (click)="removeRecentSearch(term, $event)"
                      pTooltip="Remove" tooltipPosition="left">
                      <i class="pi pi-times"></i>
                    </button>
                  </div>
                }
              </div>
            }

            <p-overlayPanel #filterPanel class="filter-panel-gmail" [showCloseIcon]="true"
              [dismissable]="true" [style]="{ width: '320px', paddingTop: '10px' }">
              <div class="p-fluid">
                <div class="field mb-3">
                  <label for="msgStartDate" class="font-semibold">Start Date</label>
                  <p-calendar appendTo="body" #startCal id="msgStartDate" [(ngModel)]="msgStartDate"
                    (onSelect)="onStartDateSelect()" (onClear)="onStartDateClear()"
                  dateFormat="yy-mm-dd" showIcon="true" appendTo="body"></p-calendar>
                </div>
                <div class="field mb-3">
                  <label for="msgEndDate" class="font-semibold">End Date</label>
                  <p-calendar appendTo="body" #endCal id="msgEndDate" [(ngModel)]="msgEndDate"
                    [minDate]="minEndDate" dateFormat="yy-mm-dd" showIcon="true"
                  appendTo="body"></p-calendar>
                </div>
                <div class="d-flex justify-content-end mt-2">
                  <button pButton label="Clear" class="p-button-text" (click)="clearDateFilters()"></button>
                  <button pButton label="Apply" icon="pi pi-check" class="p-ml-2"
                  (click)="applyDateFilter(); filterPanel.hide();"></button>
                </div>
              </div>
            </p-overlayPanel>
          </div>

          <div class="list-hdr-right">
            @if (recordTotal && lazyLoadEvent) {
              <span class="pagination-text">
                {{ (lazyLoadEvent.first || 0) + 1 }}–{{ ((lazyLoadEvent.first || 0) + (lazyLoadEvent.rows || 50)) > recordTotal ? recordTotal : ((lazyLoadEvent.first || 0) + (lazyLoadEvent.rows || 50)) }} of {{ recordTotal }}
              </span>
            }
            <button class="pagination-btn"
              (click)="prev(); pt.first = first; lazyLoadEvent.first = first; lazyLoadEvent.rows = rows || 50; loadLazy(lazyLoadEvent)"
              [disabled]="isFirstPage()">
              <i class="pi pi-chevron-left"></i>
            </button>
            <button class="pagination-btn"
              (click)="next(); pt.first = first; lazyLoadEvent.first = first; lazyLoadEvent.rows = rows || 50; loadLazy(lazyLoadEvent)"
              [disabled]="isLastPage()">
              <i class="pi pi-chevron-right"></i>
            </button>
          </div>

        </div>

        <div class="message-list-wrapper" #messageListWrapper>
          <p-treeTable #pt [value]="inboxs" [paginator]="false" dataKey="msgId" selectionMode="single"
            [loading]="loading" [columns]="columns" [lazy]="true" (onLazyLoad)="loadLazy($event)"
            (onNodeExpand)="onNodeExpand($event)" [rows]="50" [rowsPerPageOptions]="[50, 100, 200]"
            [totalRecords]="recordTotal" [resizableColumns]="true" [autoLayout]="true" [scrollable]="true"
            [(contextMenuSelection)]="selectedNode" [contextMenu]="gf" styleClass="gmail-email-table">

            <ng-template pTemplate="body" let-rowNode let-rowData="rowData" let-columns="columns">
              <tr [ttRow]="rowNode" [ttContextMenuRow]="rowNode" (click)="openSelectedMail(rowData)"
                class="gmail-email-row"
                [class.gmail-row-selected]="selectedRow === rowData"
                [class.gmail-row-unread]="!rowData?.replied">

                <td class="gmail-email-cell">
                  <div class="gmail-row-inner">

                    <!-- Checkbox -->
                    <div class="gmail-col-check" (click)="$event.stopPropagation()">
                      <p-checkbox [(ngModel)]="rowData.checkboxFlag" [binary]="true"
                      (onChange)="mailSelectionChanged(rowData)"></p-checkbox>
                    </div>

                    <!-- Star -->
                    <div class="gmail-col-star"
                      (click)="$event.stopPropagation(); toggleStar(rowData)">
                      <i class="pi gmail-star-icon"
                        [class.pi-star-fill]="rowData.starred"
                        [class.pi-star]="!rowData.starred"
                      [class.gmail-star-active]="rowData.starred"></i>
                    </div>

                    <!-- Sender -->
                    <div class="gmail-col-sender">
                      {{ rowData.senderName || rowData.senderEmail || rowData.senderMobileNum || 'Unknown' }}
                    </div>

                    <!-- Subject + from→to snippet -->
                    <div class="gmail-col-subject-area">
                      <span class="gmail-subject-text">
                        {{ rowData['subject'] || rowData['mobileText'] || 'No Subject' }}
                      </span>
                      @if ((rowData.senderEmail || rowData.senderMobileNum) && rowData.msgRecipientAPIList?.length) {
                        <span class="gmail-snippet-text"
                          >
                          &nbsp;—&nbsp;
                          @if (rowData.msgOrigin != 4) {
                            {{ rowData.senderEmail || rowData.senderMobileNum }}
                            to
                            {{ rowData.msgRecipientAPIList[0].email || rowData.msgRecipientAPIList[0].mobileNum }}
                            @if (rowData.msgRecipientAPIList.length > 1) {
                              <span class="more-recipients">
                                +{{ rowData.msgRecipientAPIList.length - 1 }}
                              </span>
                            }
                          }
                        </span>
                      }
                    </div>

                    <div class="gmail-col-right">
                      @if (rowData?.topic == 100 && rowData?.topicId) {
                        <div class="gmail-res-badge"
                          (click)="openReservation(rowData?.topicId, $event); $event.stopPropagation()"
                          pTooltip="Open Reservation" tooltipPosition="top">
                          @if (!openingReservation[rowData?.topicId]) {
                            <span>R</span>
                          }
                          @if (openingReservation[rowData?.topicId]) {
                            <i class="pi pi-spinner pi-spin"></i>
                          }
                        </div>
                      }
                      <!-- Restore from archive (only visible in archive tab) -->
                      @if (selectedmailbox === '0') {
                        <button class="gmail-inline-restore-btn"
                          (click)="restoreFromArchive(rowData); $event.stopPropagation()"
                          [disabled]="restoringMsgIds.has(rowData.msgId)"
                          [class.gmail-inline-btn--loading]="restoringMsgIds.has(rowData.msgId)"
                          [pTooltip]="rowData?.msgOrigin == 4 ? 'Move to Sent' : 'Move to Inbox'"
                          tooltipPosition="top">
                          @if (restoringMsgIds.has(rowData.msgId)) {
                            <i class="pi pi-spin pi-spinner"></i>
                          }
                          @if (!restoringMsgIds.has(rowData.msgId)) {
                            <i class="pi pi-reply"></i>
                          }
                        </button>
                      }
                      <!-- Archive (hidden in archive tab — no sense archiving something already archived) -->
                      @if (selectedmailbox !== '0') {
                        <button class="gmail-inline-archive-btn"
                          (click)="archiveMail(rowData); $event.stopPropagation()"
                          [disabled]="archivingMsgIds.has(rowData.msgId)"
                          [class.gmail-inline-btn--loading]="archivingMsgIds.has(rowData.msgId)"
                          pTooltip="Archive" tooltipPosition="top">
                          @if (archivingMsgIds.has(rowData.msgId)) {
                            <i class="pi pi-spin pi-spinner"></i>
                          }
                          @if (!archivingMsgIds.has(rowData.msgId)) {
                            <i class="pi pi-inbox"></i>
                          }
                        </button>
                      }
                      <!-- Attachment count -->
                      @if (rowData.attachmentCount > 0) {
                        <span class="gmail-attachment-indicator"
                          pTooltip="{{ rowData.attachmentCount }} attachment{{ rowData.attachmentCount > 1 ? 's' : '' }}"
                          tooltipPosition="top">
                          <i class="pi pi-paperclip"></i>{{ rowData.attachmentCount }}
                        </span>
                      }
                      <!-- Tag pills -->
                      @if (msgTagsMap[rowData.msgId]?.length) {
                        @for (tag of msgTagsMap[rowData.msgId]; track tag) {
                          <span
                            class="gmail-tag-pill"
                          [title]="tag.name">{{ tag.name }}</span>
                        }
                      }
                      <span class="gmail-date-text">
                        {{ (rowData?.receivedDate || rowData?.sentDate || rowData?.createDate) | date: 'MMM dd, h:mm a' }}
                      </span>
                    </div>

                  </div>
                </td>
              </tr>
            </ng-template>

            <ng-template pTemplate="emptymessage">
              <tr>
                <td colspan="25" class="text-center fw-bold p-2">
                  {{ loading ? 'Loading Messages...' : 'No Messages Found' }}
                </td>
              </tr>
            </ng-template>
          </p-treeTable>
        </div>

        <p-contextMenu #gf appendTo="body" [model]="items"></p-contextMenu>
      </div>

    </div>

    @if (selectedRow || mailPaneLoading) {
      <div class="inbox-resize-handle"
        (mousedown)="onSidebarResizeStart($event)"
      title="Drag to resize"></div>
    }

    @if (selectedRow || mailPaneLoading) {
      <div class="gmail-detail-view">
        @if (mailPaneLoading) {
          <div class="detail-loading-state">
            <p-progressSpinner styleClass="custom-spinner"></p-progressSpinner>
            <p class="mt-3 text-muted">Loading message…</p>
          </div>
        }
        @if (selectedMailEntry && !mailPaneLoading) {
          <div class="gmail-detail-topbar">
            <button class="gmail-back-btn"
              (click)="selectedMailEntry = null; selectedRow = null"
              title="Back to inbox">
              <i class="pi pi-arrow-left"></i>
            </button>
            <span class="gmail-detail-subject-title">
              {{ selectedMailEntry?.subject || selectedMailEntry?.mobileText || 'No Subject' }}
            </span>
          </div>
          <div class="gmail-detail-content">
            <mat-tab-group class="message-tabs" [selectedIndex]="0"
              (selectedTabChange)="onMessageTabChange($event)">
              @if (showEmailText || showEmailHtml || showSms) {
                <mat-tab
                  [label]="((showEmailText || showEmailHtml) && showSms) ? 'Mail & SMS' : ((showEmailText || showEmailHtml) ? 'Mail' : (showSms ? 'SMS' : ''))"
                  >
                  @if (showEmailText || showEmailHtml) {
                    <app-inbox
                      [inbox]="selectedMailEntry"
                      (doUpdate)="msgSent($event)"
                      (doArchive)="onMessageArchived($event)"
                      (keywordClicked)="onKeywordClicked($event)"
                      (tagsChanged)="onMessageTagsUpdated($event)"
                      [templateMsgAudience]="templateMsgAudience"
                      [showClose]="false">
                    </app-inbox>
                  }
                  @if ((showEmailText || showEmailHtml) && showSms) {
                    <hr>
                    }
                    @if (showSms) {
                      <app-inbox-sms
                        [inbox]="selectedMailEntry"
                        (keywordClicked)="onKeywordClicked($event)"
                        [showClose]="false"
                        (doAdd)="msgSent($event)"
                        (tagsChanged)="onMessageTagsUpdated($event)">
                      </app-inbox-sms>
                    }
                  </mat-tab>
                }
                <mat-tab label="Conversation">
                  @if (selectedMailEntry) {
                    <app-conversation
                      [inbox]="selectedMailEntry"
                      [showClose]="false"
                      (doUpdate)="msgSent($event)"
                      (tagsChanged)="onMessageTagsUpdated($event)">
                    </app-conversation>
                  }
                </mat-tab>
                <mat-tab label="Admin Tools">
                  <p-table [value]="tableData1" rowGroupMode="subheader" groupRowsBy="section"
                    sortField="section" sortOrder="1" responsiveLayout="scroll">
                    <ng-template pTemplate="rowgroupheader" let-rowData>
                      <tr>
                        <td colspan="5" style="font-weight:bold;background:#f4f4f4;">{{ rowData.section }}</td>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="header">
                      <tr>
                        <th>Template ID</th><th>Title</th><th>Format</th>
                        <th>Reservations</th><th>Link</th>
                      </tr>
                    </ng-template>
                    <ng-template pTemplate="body" let-row let-rowIndex="rowIndex">
                      @if (isNewSection(rowIndex)) {
                        <tr>
                          <td colspan="5" style="background:#f4f4f4;font-weight:600;padding:12px;">{{ row.section }}</td>
                        </tr>
                      }
                      <tr>
                        <td>{{ row.templateId }}</td>
                        <td>{{ row.title }}</td>
                        <td>{{ row.formate }}</td>
                        <td>
                          <p-dropdown [options]="reservationOptions" [(ngModel)]="row.selectedReservationId"
                          placeholder="Select Reservation" [showClear]="true"></p-dropdown>
                        </td>
                        <td>
                          <button pButton type="button" label="Send" class="p-button-sm p-button-success"
                          (click)="send(row)"></button>
                        </td>
                      </tr>
                    </ng-template>
                  </p-table>
                </mat-tab>
              </mat-tab-group>
            </div>
          }
        </div>
      }


    </div>
  </div>
